module.exports = __webpack_public_path__ + "img/icon-chevron-right.3c0dfbd6.svg";